import { Component, OnInit } from '@angular/core';
import { AnnotationCriteria } from 'src/app/common';
import { AnnotationService } from 'src/app/services/annotation.service';

@Component({
  selector: 'app-annotation',
  templateUrl: './annotation.component.html',
  styleUrls: ['./annotation.component.scss']
})
export class AnnotationComponent implements OnInit {

  constructor(private annotationService: AnnotationService) { }

  criteria: AnnotationCriteria = {};
  annotations: any[];
  newAnnotation: any = {};

  async ngOnInit() {
    await this.load();
  }

  private async load() {
    this.annotations = await this.annotationService.search(this.criteria);
  }

  async delete(annotation: any) {
    await this.annotationService.remove(annotation.Id);
    await this.load();
  }
  async save(annotation: any) {
    await this.annotationService.save(annotation);
    this.newAnnotation = {};
    await this.load();
  }
}
